import { Notyf, NotyfEvent } from 'notyf';
import 'notyf/notyf.min.css';

// Short messages at the top centre, below the header, in the theme's colors (styles/app.css). Messages are hints
// about what cannot be done right now, so they carry no icon and go away by themselves or when clicked.
const notyf = new Notyf({
    duration: 2500,
    ripple: false,
    position: { x: 'center', y: 'top' },
    types: [{ type: 'error', background: 'var(--ink)', icon: false }],
});

const messages = {
    error(message: string) {
        const notification = notyf.error(message);
        notification.on(NotyfEvent.Click, () => notyf.dismiss(notification));
    },
};

export default messages;
